'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'mug-saucer';
var width = 576;
var height = 512;
var aliases = ["coffee"];
var unicode = 'f0f4';
var svgPathData = ['M96 64l0 304 320 0 0-304-320 0z', 'M400 64l16 0 0 304-320 0 0-304 304 0zm48 160l0-160 16 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-16 0zm0 144l0-112 16 0c61.9 0 112-50.1 112-112S525.9 32 464 32l-400 0 0 368 384 0 0-32zM48 480l-16 0 0 32 448 0 0-32-432 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugSaucer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;